const recruitmentContent = {
  title: '채용 관리 매뉴얼',
  content: `
  <div class="page-title">[채용 관리]</div>
  
# [개요]
채용 관리 기능은 홈페이지를 통해 접수된 입사지원서를 효율적으로 관리하기 위한 도구입니다. 이 문서에서는 **지원자 정보 확인, 진행 상태 관리, 합격 여부 처리 등 전반적인 채용 관리 방법**을 확인할 수 있습니다.

### 주요 기능 요약
| 기능 | 설명 | 권한 |
|------|------------------|------------|
| 지원자 조회 | 입사지원서 목록 확인 및 검색 | 관리자 |
| 상세 정보 | 지원자 상세 정보 및 첨부파일 확인 | 관리자 |
| 합격 여부 | 각 단계별 합격/불합격 처리 | 관리자 |

# [조회]
홈페이지를 통해 접수된 입사지원 목록을 조회하고 관리할 수 있습니다.

### 📋 화면 구성 및 기능
| 영역 | 구성 | 주요 기능 |
|------|------|-----------|
| 검색 영역 | 검색 조건 및 필터 | • 경력여부<br>• 지원분야<br>• 처리상태<br>• 확인여부<br>• 지원자명<br>• 연락처 등 검색 |
| 목록 영역 | 지원자 목록 테이블 | • 지원자 기본 정보 확인<br>• 확인여부(미확인/확인완료) 표시<br>• 합격여부 상태 확인 |

> 💡 **Tip**
> - 확인여부는 이력서 첫 조회 시 자동으로 '확인완료'로 변경됩니다.
> - ZIP 다운로드 시 해당 지원자의 모든 첨부파일이 포함됩니다.

<div class="image-row">
  <div class="image-col">
    <img src="/assets/images/guide/recruit/list_isChecked_X.png" alt="입사지원 목록_미확인" />
  </div>
  <div class="image-col">
    <img src="/assets/images/guide/recruit/list_isChecked_O.png" alt="입사지원 목록_확인완료" />
  </div>
</div>

*미확인 상태(좌)와 확인완료 상태(우)의 목록 화면*

# [상세]
지원자의 상세 정보 확인, 합격 여부 처리, 첨부파일 관리 기능을 수행할 수 있습니다.

### 📋 화면 구성 및 기능
| 영역 | 구성 | 주요 기능 |
|------|------|-----------|
| 상세 정보 | 지원자 정보 영역 | • 이름, 연락처 등 기본정보 및 인적사항 확인 |
| 합격 여부 | 진행 상태 관리 | • 서류/면접 단계별 상태 관리<br>• 합격/불합격 처리<br>• 진행 상태 이력 확인 |
| 첨부 파일 | 제출 서류 관리 | • 이력서/포트폴리오 등 개별 다운로드<br>• 전체 파일 ZIP 다운로드<br>• 파일 미리보기 |

![입사지원 상세](/assets/images/guide/recruit/detail.png)
*입사지원 상세*

![합격/불합격 처리](/assets/images/guide/recruit/submit.png)
*합격/불합격 처리*

![입사지원 첨부파일](/assets/images/guide/recruit/download.png)
*입사지원 첨부파일*
    `,
};
export default recruitmentContent;
